// extracted by mini-css-extract-plugin
export default {"cls1":"VeloScrim-Scrim_cls1__QC7R7","cls2":"VeloScrim-Scrim_cls2__j6LPu VeloScrim-Scrim_cls1__QC7R7","transparent":"VeloScrim-Scrim_transparent__yFa7R"};